import { render, staticRenderFns } from "./ddo-asset-group-category-asset-group-view.vue?vue&type=template&id=5d7b6c38&scoped=true"
import script from "./ddo-asset-group-category-asset-group-view.vue?vue&type=script&lang=js"
export * from "./ddo-asset-group-category-asset-group-view.vue?vue&type=script&lang=js"
import style0 from "./ddo-asset-group-category-asset-group-view.vue?vue&type=style&index=0&id=5d7b6c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7b6c38",
  null
  
)

export default component.exports